import React, { useState } from 'react';
import { MapPin, Calendar, Users, Star, ArrowRight, Phone, Mail, MessageCircle, X } from 'lucide-react';
import Putrijaganath from '../Assets/WhatsApp Image 2025-12-11 at 9.43.06 PM.jpeg'

const TourPackagesPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [bookingDetails, setBookingDetails] = useState({
    name: '',
    phone: '',
    email: '',
    travelers: '1',
    travelDate: ''
  });

  const tourPackages = [
    // Spiritual Tours
    {
      id: 1,
      title: "Jagannath Puri & Chilika",
      location: "Odisha",
      duration: "4 Days / 3 Nights",
      price: "₹12,999",
      image: Putrijaganath,
      rating: 4.8,
      category: "spiritual",
      highlights: ["Jagannath Temple", "Chilika Lake", "Puri Beach"]
    },
    {
      id: 2,
      title: "Ayodhya Spiritual Tour",
      location: "Uttar Pradesh",
      duration: "3 Days / 2 Nights",
      price: "₹9,999",
      image: "https://heritagecabs.in/assets/frontend/images/Interesting.webp",
      rating: 4.9,
      category: "spiritual",
      highlights: ["Ram Mandir", "Hanuman Garhi", "Kanak Bhawan"]
    },
    {
      id: 3,
      title: "Amritsar Punjab Heritage",
      location: "Punjab",
      duration: "3 Days / 2 Nights",
      price: "₹10,999",
      image: "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/03/46/0a/1d/the-golden-temple-where.jpg?w=1200&h=-1&s=1",
      rating: 4.9,
      category: "spiritual",
      highlights: ["Golden Temple", "Wagah Border", "Jallianwala Bagh"]
    },
    {
      id: 4,
      title: "Varanasi Spiritual Journey",
      location: "Uttar Pradesh",
      duration: "3 Days / 2 Nights",
      price: "₹11,999",
      image: "https://substackcdn.com/image/fetch/$s_!uncf!,f_auto,q_auto:good,fl_progressive:steep/https%3A%2F%2Fsubstack-post-media.s3.amazonaws.com%2Fpublic%2Fimages%2F1185c48d-bcde-4633-8034-6ee871093dad_800x400.jpeg",
      rating: 4.8,
      category: "spiritual",
      highlights: ["Ganga Aarti", "Kashi Vishwanath", "Sarnath"]
    },
    {
      id: 5,
      title: "Tirupati Balaji Darshan",
      location: "Andhra Pradesh",
      duration: "2 Days / 1 Night",
      price: "₹8,999",
      image: "https://blog.yatradham.org/wp-content/uploads/2020/01/Tirumala-Tirupati-Temple-Timings.jpg",
      rating: 4.7,
      category: "spiritual",
      highlights: ["Tirupati Temple", "Seven Hills", "Kapila Theertham"]
    },

    // Adventure Tours
    {
      id: 6,
      title: "Shimla Manali Adventure",
      location: "Himachal Pradesh",
      duration: "6 Days / 5 Nights",
      price: "₹18,999",
      image: "https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?w=800&q=80",
      rating: 4.7,
      category: "adventure",
      highlights: ["Solang Valley", "Rohtang Pass", "Mall Road"]
    },
    {
      id: 7,
      title: "Leh Ladakh Expedition",
      location: "Ladakh",
      duration: "7 Days / 6 Nights",
      price: "₹28,999",
      image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80",
      rating: 5.0,
      category: "adventure",
      highlights: ["Pangong Lake", "Nubra Valley", "Khardung La"]
    },
    {
      id: 8,
      title: "Rishikesh Adventure Camp",
      location: "Uttarakhand",
      duration: "3 Days / 2 Nights",
      price: "₹12,999",
      image: "https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=800&q=80",
      rating: 4.6,
      category: "adventure",
      highlights: ["River Rafting", "Bungee Jumping", "Camping"]
    },

    // Nature Tours
    {
      id: 9,
      title: "Kashmir Paradise",
      location: "Jammu & Kashmir",
      duration: "5 Days / 4 Nights",
      price: "₹22,999",
      image: "https://5.imimg.com/data5/OK/YU/DM/SELLER-33615216/kashmir-paradise-tour-packages-service.png",
      rating: 5.0,
      category: "nature",
      highlights: ["Dal Lake", "Gulmarg", "Pahalgam"]
    },
    {
      id: 10,
      title: "Ooty Coimbatore Hills",
      location: "Tamil Nadu",
      duration: "4 Days / 3 Nights",
      price: "₹11,999",
      image: "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?w=800&q=80",
      rating: 4.6,
      category: "nature",
      highlights: ["Botanical Gardens", "Doddabetta Peak", "Tea Estates"]
    },
    {
      id: 11,
      title: "Munnar Tea Gardens",
      location: "Kerala",
      duration: "4 Days / 3 Nights",
      price: "₹13,999",
      image: "https://cdn.getyourguide.com/image/format=auto,fit=crop,gravity=center,quality=60,width=450,height=450,dpr=2/tour_img/1fb00102a08d0c3d2f3e93631c3b56847ae8841fa258c15c20be4dca0824e2de.png",
      rating: 4.8,
      category: "nature",
      highlights: ["Tea Plantations", "Eravikulam Park", "Mattupetty Dam"]
    },
    {
      id: 12,
      title: "Coorg Coffee Estates",
      location: "Karnataka",
      duration: "3 Days / 2 Nights",
      price: "₹10,999",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTlYJvuby3HIN6wEIeW-2OoHmG540hVs8lZnA&s",
      rating: 4.7,
      category: "nature",
      highlights: ["Coffee Plantations", "Abbey Falls", "Raja's Seat"]
    },
    {
      id: 13,
      title: "Alleppey Backwaters",
      location: "Kerala",
      duration: "3 Days / 2 Nights",
      price: "₹14,999",
      image: "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?w=800&q=80",
      rating: 4.9,
      category: "nature",
      highlights: ["Houseboat Stay", "Backwater Cruise", "Village Tour"]
    },

    // City Tours
    {
      id: 14,
      title: "Bangalore Explorer",
      location: "Karnataka",
      duration: "3 Days / 2 Nights",
      price: "₹8,999",
      image: "https://images.unsplash.com/photo-1596176530529-78163a4f7af2?w=800&q=80",
      rating: 4.5,
      category: "city",
      highlights: ["Lalbagh", "Cubbon Park", "Palace Gardens"]
    },
    {
      id: 15,
      title: "Chennai Heritage Tour",
      location: "Tamil Nadu",
      duration: "3 Days / 2 Nights",
      price: "₹9,999",
      image: "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&q=80",
      rating: 4.6,
      category: "city",
      highlights: ["Marina Beach", "Mahabalipuram", "Kapaleeshwarar Temple"]
    },
    {
      id: 16,
      title: "Hyderabad Nizami Tour",
      location: "Telangana",
      duration: "3 Days / 2 Nights",
      price: "₹9,499",
      image: "https://media.assettype.com/outlooktraveller/2023-11/58bf5022-fe68-486a-818b-171ebbd1f72f/shutterstock_1737038879.jpg?w=1200&h=675&auto=format%2Ccompress&fit=max&enlarge=true",
      rating: 4.7,
      category: "city",
      highlights: ["Charminar", "Golconda Fort", "Ramoji Film City"]
    },
    {
      id: 17,
      title: "Delhi Golden Triangle",
      location: "Delhi",
      duration: "4 Days / 3 Nights",
      price: "₹15,999",
      image: "https://images.unsplash.com/photo-1587474260584-136574528ed5?w=800&q=80",
      rating: 4.8,
      category: "city",
      highlights: ["Red Fort", "Qutub Minar", "India Gate"]
    },
    {
      id: 18,
      title: "Jaipur Pink City",
      location: "Rajasthan",
      duration: "3 Days / 2 Nights",
      price: "₹12,999",
      image: "https://media.istockphoto.com/id/1398087835/photo/pink-palace-hawa-mahal-jaipur-india-beautiful-sunset-view.jpg?s=612x612&w=0&k=20&c=S8X6bk4Mdp0xu624dFZCHfobotdwdIp7K1FEQJV6hkI=",
      rating: 4.9,
      category: "city",
      highlights: ["Amber Fort", "Hawa Mahal", "City Palace"]
    },
    {
    id: 101,
    title: "Kolkata Spiritual & Heritage Tour",
    location: "Kolkata, West Bengal",
    duration: "2 Days / 1 Night",
    price : "₹7,499",
    image: "https://media.tacdn.com/media/attractions-splice-spp-674x446/10/2a/10/7f.jpg",
    rating: 4.6,
    category: "spiritual",
    highlights: ["Dakshineswar Kali Temple", "Belur Math", "Kalighat Temple", "St. Paul's Cathedral"]
  },
  {
    id: 102,
    title: "Kolkata Cultural Capital Experience",
    location: "Kolkata, West Bengal",
    duration: "3 Days / 2 Nights",
    price: "₹12,999",
    image: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEi_OHPbOnMERwW21FJZz5zYswTODS64lOooqzmc4NmFv9ypTS_f_uCHNoGHFlWTs-V8WRaP_IV84q4zmRFb6FH1chOdwoECQSeB8FG2-jls9QwUhcdcn2XWjeCE_6mUddbFYqizWBh_I2w/s1600/800px-India_Education_.jpg",
    rating: 4.8,
    category: "cultural",
    highlights: ["Victoria Memorial", "Indian Museum", "Howrah Bridge", "Kumartuli Potter's Colony", "Park Street"]
  },
  {
    id: 103,
    title: "Weekend Getaway to Kolkata",
    location: "Kolkata, West Bengal",
    duratio: "2 Days / 1 Night",
    price: "₹6,999",
    image: "https://assets.simplotel.com/simplotel/image/upload/x_0,y_146,w_1920,h_1080,r_0,c_crop,q_80,fl_progressive/w_500,f_auto,c_fit/kenilworth-hotel-kolkata/indian-museum-3382432_1920_vxzrr2",
    rating: 4.5,
    category: "heritage",
    highlights: ["Princep Ghat", "Marble Palace", "South Park Street Cemetery", "College Street Book Market", "Eden Gardens"]
  }
  ]

  const categories = [
    { id: 'all', name: 'All Tours' },
    { id: 'spiritual', name: 'Spiritual' },
    { id: 'adventure', name: 'Adventure' },
    { id: 'nature', name: 'Nature' },
    { id: 'city', name: 'City Tours' }
  ];

  const filteredPackages = selectedCategory === 'all' 
    ? tourPackages 
    : tourPackages.filter(pkg => pkg.category === selectedCategory);

  const handleBookNow = (pkg) => {
    setSelectedPackage(pkg);
    setShowBookingModal(true);
  };

  const handleInputChange = (e) => {
    setBookingDetails({
      ...bookingDetails,
      [e.target.name]: e.target.value
    });
  };

  const sendToWhatsApp = () => {
    const { name, phone, email, travelers, travelDate } = bookingDetails;
    
    if (!name || !phone) {
      alert('Please fill in your name and phone number');
      return;
    }

    // Your WhatsApp number (replace with your actual number)
    const whatsappNumber = '919728115781'; // Format: country code + number (no + or spaces)
    
    const message = `*New Tour Booking Inquiry*
    
📍 *Package:* ${selectedPackage.title}
📅 *Duration:* ${selectedPackage.duration}
💰 *Price:* ${selectedPackage.price}
📍 *Location:* ${selectedPackage.location}

👤 *Customer Details:*
Name: ${name}
Phone: ${phone}
Email: ${email || 'Not provided'}
Number of Travelers: ${travelers}
Preferred Travel Date: ${travelDate || 'Not specified'}

*Highlights:*
${selectedPackage.highlights.map(h => `• ${h}`).join('\n')}

Looking forward to booking this amazing tour! 🌟`;

    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    
    window.open(whatsappURL, '_blank');
    
    // Close modal and reset form
    setShowBookingModal(false);
    setBookingDetails({
      name: '',
      phone: '',
      email: '',
      travelers: '1',
      travelDate: ''
    });
  };

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}
     

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-b from-gray-900 to-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-5xl md:text-6xl font-bold mb-6">
            Discover <span className="text-yellow-500">Incredible India</span>
          </h2>
          <p className="text-xl text-gray-400 mb-8 max-w-2xl mx-auto">
            Curated tour packages to India's most breathtaking destinations. Experience spirituality, adventure, and natural beauty.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <div className="bg-gray-800 px-6 py-3 rounded-lg">
              <div className="text-2xl font-bold text-yellow-500">18+</div>
              <div className="text-sm text-gray-400">Tour Packages</div>
            </div>
            <div className="bg-gray-800 px-6 py-3 rounded-lg">
              <div className="text-2xl font-bold text-yellow-500">15+</div>
              <div className="text-sm text-gray-400">Destinations</div>
            </div>
            <div className="bg-gray-800 px-6 py-3 rounded-lg">
              <div className="text-2xl font-bold text-yellow-500">4.8★</div>
              <div className="text-sm text-gray-400">Average Rating</div>
            </div>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 bg-gray-900/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map(category => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-2 rounded-full font-medium transition ${
                  selectedCategory === category.id
                    ? 'bg-yellow-500 text-black'
                    : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
          <p className="text-center text-gray-400 mt-4">
            {filteredPackages.length} packages available
          </p>
        </div>
      </section>

      {/* Tour Packages Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredPackages.map(pkg => (
              <div
                key={pkg.id}
                className="bg-gray-900 rounded-xl overflow-hidden border border-gray-800 hover:border-yellow-500/50 transition group"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={pkg.image}
                    alt={pkg.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition duration-500"
                  />
                  <div className="absolute top-4 right-4 bg-yellow-500 text-black px-3 py-1 rounded-full font-bold text-sm">
                    {pkg.price}
                  </div>
                  <div className="absolute top-4 left-4 bg-black/70 backdrop-blur-sm px-3 py-1 rounded-full flex items-center space-x-1">
                    <Star className="w-4 h-4 text-yellow-500 fill-yellow-500" />
                    <span className="text-sm font-medium">{pkg.rating}</span>
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-2 group-hover:text-yellow-500 transition">
                    {pkg.title}
                  </h3>
                  
                  <div className="flex items-center text-gray-400 text-sm mb-4">
                    <MapPin className="w-4 h-4 mr-1" />
                    <span>{pkg.location}</span>
                  </div>

                  <div className="flex items-center text-gray-400 text-sm mb-4">
                    <Calendar className="w-4 h-4 mr-2" />
                    <span>{pkg.duration}</span>
                  </div>

                  <div className="mb-4">
                    <p className="text-sm text-gray-500 mb-2">Highlights:</p>
                    <div className="flex flex-wrap gap-2">
                      {pkg.highlights.map((highlight, idx) => (
                        <span
                          key={idx}
                          className="text-xs bg-gray-800 px-2 py-1 rounded"
                        >
                          {highlight}
                        </span>
                      ))}
                    </div>
                  </div>

                  <button 
                    onClick={() => handleBookNow(pkg)}
                    className="w-full bg-yellow-500 hover:bg-yellow-400 text-black font-bold py-3 rounded-lg flex items-center justify-center space-x-2 transition"
                  >
                    <span>Book Now</span>
                    <ArrowRight className="w-5 h-5" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Booking Modal */}
      {showBookingModal && (
  <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
    <div className="bg-gray-900 rounded-xl max-w-sm w-full p-6 relative border border-yellow-500/30 shadow-xl">
      <button 
        onClick={() => setShowBookingModal(false)}
        className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors"
      >
        <X className="w-5 h-5" />
      </button>

      <h3 className="text-xl font-bold mb-1 text-yellow-500">Book Your Tour</h3>
      <p className="text-gray-400 text-sm mb-4 truncate">{selectedPackage?.title}</p>

      <div className="space-y-3">
        <div>
          <label className="block text-sm font-medium mb-1.5">Your Name *</label>
          <input
            type="text"
            name="name"
            value={bookingDetails.name}
            onChange={handleInputChange}
            className="w-full bg-gray-800 border border-gray-700 rounded-lg px-3 py-2.5 text-sm text-white focus:border-yellow-500 focus:outline-none transition-colors"
            placeholder="Enter your name"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1.5">Phone Number *</label>
          <input
            type="tel"
            name="phone"
            value={bookingDetails.phone}
            onChange={handleInputChange}
            className="w-full bg-gray-800 border border-gray-700 rounded-lg px-3 py-2.5 text-sm text-white focus:border-yellow-500 focus:outline-none transition-colors"
            placeholder="Enter phone number"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1.5">Email (Optional)</label>
          <input
            type="email"
            name="email"
            value={bookingDetails.email}
            onChange={handleInputChange}
            className="w-full bg-gray-800 border border-gray-700 rounded-lg px-3 py-2.5 text-sm text-white focus:border-yellow-500 focus:outline-none transition-colors"
            placeholder="Enter email"
          />
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-sm font-medium mb-1.5">Travelers</label>
            <select
              name="travelers"
              value={bookingDetails.travelers}
              onChange={handleInputChange}
              className="w-full bg-gray-800 border border-gray-700 rounded-lg px-3 py-2.5 text-sm text-white focus:border-yellow-500 focus:outline-none transition-colors"
            >
              {[1, 2, 3, 4, 5, 6 ,7 ,8,9,10].map(num => (
                <option key={num} value={num}>{num} {num === 1 ? 'Person' : 'People'}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium mb-1.5">Travel Date</label>
            <input
              type="date"
              name="travelDate"
              value={bookingDetails.travelDate}
              onChange={handleInputChange}
              className="w-full bg-gray-800 border border-gray-700 rounded-lg px-3 py-2.5 text-sm text-white focus:border-yellow-500 focus:outline-none transition-colors"
            />
          </div>
        </div>

        <button
          onClick={sendToWhatsApp}
          className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 rounded-lg flex items-center justify-center space-x-2 transition-all duration-200 mt-2"
        >
          <MessageCircle className="w-4 h-4" />
          <span className="text-sm">Send via WhatsApp</span>
        </button>
      </div>
    </div>
  </div>
)}

      {/* CTA Section */}
      {/* <section className="py-20 bg-gradient-to-t from-gray-900 to-black border-t border-yellow-500/20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Ready to Start Your Journey?</h2>
          <p className="text-xl text-gray-400 mb-8">
            Get in touch with our travel experts to customize your perfect tour package
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-yellow-500 hover:bg-yellow-400 text-black font-bold px-8 py-4 rounded-lg flex items-center justify-center space-x-2 transition">
              <Phone className="w-5 h-5" />
              <span>Call Now</span>
            </button>
            <button className="bg-green-600 hover:bg-green-700 text-white font-bold px-8 py-4 rounded-lg flex items-center justify-center space-x-2 transition">
              <MessageCircle className="w-5 h-5" />
              <span>WhatsApp Us</span>
            </button>
          </div>
        </div>
      </section> */}

      {/* Footer */}

    </div>
  );
};

export default TourPackagesPage;